import React from 'react';
import { Box as MuiBox, BoxProps as MuiBoxProps } from '@mui/material';

export interface BoxProps extends MuiBoxProps {}

const Box = React.forwardRef<HTMLDivElement, BoxProps>(({ children, ...rest }, ref) => {
	return (
		<MuiBox ref={ref} {...rest}>
			{children}
		</MuiBox>
	);
});

Box.displayName = 'Box';

export default Box;
